
import './App.css';
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import MobileNav from './Components/MobileNav/MobileNav';


function App() {
  return (
    <div className="App">
    <Header></Header>
   <Home></Home>

   <MobileNav></MobileNav>
   <Footer></Footer>
    </div>
  );
}

export default App;
